import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import { useTranslation } from "react-i18next";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { ActionButtons } from '../../../components/others/ActionButtons';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { StoreForm } from '../../../components/store/StoreForm';
import { Products } from '../../../components/store/Products';
import { getCompanies } from '../../../services/service.service';
import { create, update, fetchRegister } from '../../../services/store.service';
import moment from 'moment';

const initialState = {
    type: '',
    type_responsible: '',
    responsible: '',
    type_document: '',
    document: '',
    observation: '',
    warehouse: '',
    created_at: new Date().toISOString(),
    products: []
}
export const StoreLayout = () => {
    const [values, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(initialState);
    const [loading, setLoading] = useState(false);
    const [isView, setIsView] = useState(false);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [workFlow, setWorkFlow] = useState('');
    
    const { t } = useTranslation();
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const productsFormRef = useRef();
    const formRef = useRef();

    const fetchDataService = async (id) => {
        try {
            const response = await fetchRegister(id, userSession.token);
            if (response.status === 200 && response.data?.length > 0) {
                const baseData = response.data[0];
                const parsedProducts = Array.isArray(JSON.parse(baseData.products))
                    ? JSON.parse(baseData.products).map((p) => ({
                        id_warehouse_register_product: p.id_warehouse_register_product,
                        id_warehouse_register: p.id_warehouse_register,
                        id_product_service: p.id_warehouse_product_service,
                        code: p.code_sku || '', 
                        name: p.name || '', 
                        unit_description: p.unit_description || '',
                        quantity: p.amount ?? 0, 
                        expected_quantity: p.amount_expected ?? 0,
                        state: p.status ?? '', 
                        observation: p.observation ?? '',
                        isCreated: false, 
                        created: p.created,
                        created_by: p.created_by
                    }))
                    : [];

                const data = {
                    ...baseData,
                    created: moment(baseData.created.split('T')[0], 'YYYY-MM-DD').toDate(),
                    products: parsedProducts,
                };
                setAllInfo(data);
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching warehouse register data:", error);
        }
    };

    useEffect(() => {
        if (location.state?.config) {
            const { config } = location.state;
            const wf = config.data?.work_flow;
            setWorkFlow(wf);
            if (config.data?.id_warehouse_register && wf === "FLOW_PROCESS-VIEW_REGISTER") {
                setIsView(true);
                setLoading(true);
                fetchDataService(config.data?.id_warehouse_register);
            } else {
                const fetchCompanies = async () => {
                    try {
                        const response = await getCompanies('50', userSession.token);
                        setCompanies(response.data || []);
                        if (response.data && response.data.length === 1) {
                            const dto = response.data[0];
                            handleDirectInputChange("id_company", dto.id_company);
                            setOpenDialogCompany(false);
                        }else
                            setOpenDialogCompany(true);
                    } catch (e) {
                        console.log(e.message);
                    } finally {
                        setLoading(false);
                    }
                }
                fetchCompanies();
            }
        }
    }, [userSession.token]);


    const handleConfirmAction = useCallback(async (dto) => {
        handleDirectInputChange("id_company", dto.id_company)
        setOpenDialogCompany(false);
    }, []);

    const handleSubmit = async () => {
        const isValidForm = formRef.current?.validForm();
        const isValidProductsForm = productsFormRef.current?.validForm();
        if(!isValidForm || !isValidProductsForm) {
            sendNotification({ msg: t('validation.requiredFieldsMissing'), variant: 'error' });
            return;
        }else{
            const data = {
                ...values,
                type: workFlow === "ADD-REGISTER" ? 'IN' : 'OUT',
                type_responsible: '',
                type_document: workFlow === "ADD-REGISTER" ? 'Order Reference' : 'Bill of Sale',
            };
            // console.log("data", data);
            // if (isEdit) {
            //     await update(data, userSession.token);
            // } else {
            await create(data, userSession.token);
            // }
            sendNotification({ msg: t('messages.saveSuccess'), variant: 'success' });
            Cancel()
        }
    };

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
    };
  return (
    <Box sx={{ width: '90%', mx: 'auto' }}>
        <Typography variant="h4" gutterBottom>
            {t('warehouse.title')}
        </Typography>

        <Card sx={{ mb: 3 }}>
            <CardContent>
                <StoreForm 
                    ref={formRef}
                    dto={values}
                    handleInputChange={handleInputChange}
                    handleDirectInputChange={handleDirectInputChange}
                    isView={isView}
                />
                {values.products.length > 0 && (
                    <Box sx={{ mt: 4 }}>
                        <DividerGradient />
                        <Products 
                            ref={productsFormRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={values}
                            isView={isView}
                        />
                    </Box>
                )}
                <ActionButtons
                    onCancel={Cancel}
                    onSubmit={handleSubmit}
                    submitLabel={t('save')}
                    disabledSubmit={isView}
                />
            </CardContent>
        </Card>
        <DialogSelectCompany
            openDialogConfirm={openDialogCompany}
            handleCancelConfirm={Cancel}
            handleConfirmAction={handleConfirmAction}
            data={companies}
        />
        <LoadingOverlay isOpen={loading} />
    </Box>
  )
}
